import React from "react";
import { Field, reduxForm, stopSubmit } from "redux-form";
import { Form, FormGroup, Label, Alert } from "reactstrap";

import TextInput from "../../../system/fields/TextInput";
import SelectDropdown from "../../../system/fields/SelectDropdown";
import FileUpload from "../../../system/fields/FileUpload";
import StarRating from "../../../system/fields/StarRating";

import * as validations from "../../../system/utils/Validation";
import DatePickerOld from "../../../system/fields/DatePickerOld";
import RichTextEditor from "react-rte";
import Wysiwyg from "../../../system/fields/Wysiwyg";

let EditForm = (props, { fields }) => {
  const { handleSubmit, mode } = props;
  return (
    <section className="edit-form">
      <Form onSubmit={handleSubmit}>
        <section className="form-section">
          <div className="form-section-header">Callback Details</div>

          <div className="row">
            <FormGroup className="col-12 col-sm-6">
              <Label htmlFor="email">First Name</Label>
              <Field
                name="first_name"
                component={TextInput}
                placeholder="First Name"
                type="text"
                validate={validations.required}
                disabled
              />
            </FormGroup>

            <FormGroup className="col-12 col-sm-6">
              <Label htmlFor="email">Last Name</Label>
              <Field
                name="last_name"
                placeholder="Last Name"
                component={TextInput}
                type="text"
                validate={validations.required}
                disabled
              />
            </FormGroup>
          </div>

          <div className="row">
            <FormGroup className="col-6">
              <Label htmlFor="email">Callback Time</Label>
              <Field
                name="callback_date.date"
                component={DatePickerOld}
                dateFormat={"MMM dd yyyy h:mm a"}
                showTimeSelect
                timeFormat="HH:mm"
                timeIntervals={15}
                popperPlacement="bottom-end"
                popperModifiers={{
                  offset: {
                    enabled: true,
                    offset: "5px, 10px",
                  },
                }}
                className="form-control"
                disabled
              />
            </FormGroup>
            <FormGroup className="col-12 col-sm-6">
              <Label htmlFor="email">Email Address</Label>
              <Field
                name="email"
                component={TextInput}
                type="email"
                validate={[validations.required, validations.email]}
                disabled
              />
            </FormGroup>
            <FormGroup className="col-12 col-sm-6">
              <Label htmlFor="email">Phone Number</Label>
              <Field
                name="phone_number"
                component={TextInput}
                type="phone"
                validate={[validations.required, validations.phoneNumber]}
                disabled
              />
            </FormGroup>
            <FormGroup className="col-12 col-sm-6">
              <Label htmlFor="email">Referrer</Label>
              <Field name="ref" component={TextInput} type="text" disabled />
            </FormGroup>
            <FormGroup className="col-12">
              <Label htmlFor="email">GCLID</Label>
              <Field name="gclid" component={TextInput} type="text" disabled />
            </FormGroup>
            <FormGroup className="col-12 ">
              <Label htmlFor="email">Comments</Label>
              <Field
                name="comments"
                component={TextInput}
                type="textarea"
                disabled
              />
            </FormGroup>
          </div>
        </section>
      </Form>

      {props.submitFailed && (
        <div className="error-container">
          <Alert color="danger">
            <strong>There are errors in your form.</strong>
            <br />
            Please check before submitting again.
          </Alert>
        </div>
      )}
    </section>
  );
};

EditForm = reduxForm({
  form: "CallbackForm",
  onChange: (values, dispatch, props) => {
    if (props.error || props.submitFailed) {
      dispatch(stopSubmit("TestForm"));
    }
  },
})(EditForm);

export default EditForm;



// WEBPACK FOOTER //
// ./src/containers/Enquiries/Callback/Form.jsx